import type { ActionConfig } from "@smartsuite/automation-engine-api";
import { INPUT_SOLUTION_ID } from "./constants";
import { recordListIdentity } from "./record-list-identity";

const solutionIdOf = (action: ActionConfig | undefined): string | undefined =>
  recordListIdentity(
    action,
    (recordList) => recordList.solutionId,
    INPUT_SOLUTION_ID,
  );

/**
 * The solution an action reads and writes.
 *
 * It is the solution of the records the action was handed, else the one its
 * own `solution-id` input points at -- which the user can point at a solution
 * other than the one hosting the automation. Everything else -- including
 * trigger inputs, where there is no action at all -- operates on the hosting
 * solution.
 */
export const actionSolutionId = (
  action: ActionConfig | undefined,
  hostSolutionId: string,
): string => solutionIdOf(action) ?? hostSolutionId;

/**
 * Solution ids the given actions reach into, in action order and deduplicated.
 * The hosting solution is loaded separately.
 */
export const collectActionSolutionIds = (
  actions: readonly ActionConfig[],
): string[] => {
  const solutionIds = actions
    .map((action) => solutionIdOf(action))
    .filter((solutionId): solutionId is string => solutionId !== undefined);

  return [...new Set(solutionIds)];
};
